import React, { Fragment } from 'react';
import { Button } from '@marvelapp/ui';
import { SpecsPanel } from '@marvelapp/ui-internal';
import * as screenLocation from '../../../constants/sourcePlatform';
import ElementAssets from '../../../containers/handoff/sidebar/ElementAssets';
import EmptyState from './EmptyState';
import { FindHowToDownloadAssetsButton } from './SidebarState';
export default function ScreenAssets(_a) {
    var areDownloading = _a.areDownloading, download = _a.download, elements = _a.elements, sourcePlatform = _a.sourcePlatform;
    return (React.createElement(SpecsPanel, { renderLink: function () {
            return elements.length > 0 && (React.createElement(Button, { bg: "transparent", color: "marvelDark", fontWeight: 400, onClick: download, px: 0 }, areDownloading ? 'Downloading assets...' : 'Download all assets'));
        }, title: "Screen assets" }, elements.length === 0 ? (React.createElement(EmptyState, { heading: "No assets yet!", message: getSidebarStateMsg(sourcePlatform) }, sourcePlatform === screenLocation.SKETCH && (React.createElement(FindHowToDownloadAssetsButton, null)))) : (elements.map(function (element) { return (React.createElement(Fragment, { key: element.id },
        React.createElement(ElementAssets, { element: element, previewOnTop: true }))); }))));
}
function getSidebarStateMsg(sourcePlatform) {
    if (sourcePlatform === screenLocation.SKETCH) {
        return 'Set layers as exportable in Sketch and we will list them here.';
    }
    return 'Insert an image or icon from our Design tool to see it here.';
}
